import styled from 'styled-components';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

export const ShareLabel = styled(Typography)`
  font-size: 0.875rem;
  margin-bottom: 0.5em;
`;

export const ActionsGrid = styled(Grid)`
  margin-top: 1em;
  padding-top: 0.5em;
  border-top: 1px solid #979797;
`;
